import { withStyles } from '@material-ui/core';

import ParasiteCursorAreasTrimmer from './component';
import styles from './styles';

export default withStyles(styles)(ParasiteCursorAreasTrimmer);
